/**
 * @generated SignedSource<<d82c1f78a0ff79dbf62ffa53c2e49a21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchMessageFeedbackFooterFragment$data = {
  readonly brainSearchMessageFeedback: {
    readonly rating: number;
  } | null;
  readonly id: string;
  readonly messageText: string;
  readonly " $fragmentType": "BrainSearchMessageFeedbackFooterFragment";
};
export type BrainSearchMessageFeedbackFooterFragment$key = {
  readonly " $data"?: BrainSearchMessageFeedbackFooterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMessageFeedbackFooterFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchMessageFeedbackFooterFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messageText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrainSearchMessageFeedbackNode",
      "kind": "LinkedField",
      "name": "brainSearchMessageFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rating",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrainSearchMessage",
  "abstractKey": null
};

(node as any).hash = "0d031f205bdc7a0c6a568d99d0f1cebc";

export default node;
